import { writable } from "svelte/store";
export const web = writable("https://vector-api-r2.omnitracs.online/v1/");
export const token = writable(null);
export const map_status = writable(false);
export const token_full = writable(null);
